import { apiUser } from "@/services/users/schemas"
import { z } from "zod"

export const apiMe = apiUser.extend({
  rememberMeToken: z.string().nullable(),
})
export type ApiMe = z.infer<typeof apiMe>
